import { apiPost, API_URI } from "api";

const search = async (clientId: number, searchTerm: string) => {
    const data = await apiPost(`${API_URI}/api/search`, {
        ClientId: clientId,
        Term: searchTerm
    });
    return data;
}

export default search;